import { some } from '../../../../common/constants';
import * as React from 'react';
import DialogCustom from '../../../../common/component/DialogCustom';
import { Box } from '@mui/material';
import SchemaForm from '../../../../common/SchemaForm';
import { PAYMENT_METHOD } from 'modules/common/apiConstants';

interface Props {
  open: boolean;
  onClose?: () => void;
  onSubmit?: (value: some) => void;
  prepaymentDetail?: some;
}

const PaymentMethodDialog: React.FunctionComponent<Props> = (props) => {
  const { onClose, open, onSubmit, prepaymentDetail } = props;

  return (
    <DialogCustom
      open={open}
      onClose={onClose}
      title={'therapy.prepayment.refund.title.refundDialog'}
      maxWidth="sm"
      PaperProps={{
        style: { minWidth: 480 },
      }}
    >
      <Box padding={2}>
        <SchemaForm
          onCancel={onClose}
          onSubmit={onSubmit}
          schema={{
            fields: ({ formProps: { intl, appState } }) => {
              return {
                amount: {
                  type: 'number-field',
                  inputType: 'number',
                  label: intl.formatMessage({ id: 'therapy.cashier.dialog.label.refundAmount' }),
                  placeholder: intl.formatMessage({ id: 'select' }),
                  register: {
                    required: true,
                    max: {
                      value: prepaymentDetail?.amount,
                      message: intl.formatMessage({ id: 'therapy.cashier.prepaymentRefund.message.invalidAmount' }),
                    },
                  },
                  tooltipError: true,
                  propsWrapper: { xs: 6 },
                },
                paymentMethod: {
                  type: 'select',
                  defaultValue: PAYMENT_METHOD.CASH.value,
                  label: intl.formatMessage({ id: 'common.refund.paymentMethod' }),
                  placeholder: intl.formatMessage({ id: 'select' }),
                  options: Object.values(PAYMENT_METHOD).filter(
                    (item) => item.value !== PAYMENT_METHOD.PREPAYMENT.value,
                  ),
                  disableClearBtn: true,
                  style: { width: 248 },
                  register: { required: true },
                  propsWrapper: { xs: 6 },
                },
                note: {
                  type: 'text-field',
                  label: intl.formatMessage({ id: 'refundReason' }),
                  placeholder: intl.formatMessage({ id: 'enter' }),
                  rows: 3,
                  multiline: true,
                  propsWrapper: { xs: 12 },
                  register: {
                    required: true,
                    maxLength: {
                      value: 256,
                      message: intl.formatMessage({ id: 'common.text.length.invalid' }),
                    },
                  },
                },
              };
            },
          }}
        />
      </Box>
    </DialogCustom>
  );
};

export default PaymentMethodDialog;
